import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import {lang} from './lang.js'

const langStorage = localStorage.getItem('i18nextLng');

i18n
   .use(Backend)
   .use(LanguageDetector)
   .use(initReactI18next)
   .init({
     resources:{
       en: {translation: lang.en[process.env.REACT_APP_SITE === 'amnito' ? 'amnito' : 'postex']},
       fa: {translation: lang.fa[process.env.REACT_APP_SITE === 'amnito' ? 'amnito' : 'postex']},
     },
     lng: langStorage ? langStorage : 'fa',
     fallbackLng: 'fa',
     debug: false,

     interpolation: {
       escapeValue: false, // not needed for react as it escapes by default
     }
   });


export default i18n;
